import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/inventories/new/loading';

export const Route = createFileRoute('/_private/inventory/new')({
  pendingComponent: Loading,
});
